module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic13.eff394a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic13.png
// module id = 478
// module chunks = 1